import { render, staticRenderFns } from "./subprogram-additional-doc-input.vue?vue&type=template&id=343bc3ca&scoped=true&"
import script from "./subprogram-additional-doc-input.vue?vue&type=script&lang=js&"
export * from "./subprogram-additional-doc-input.vue?vue&type=script&lang=js&"
import style0 from "./subprogram-additional-doc-input.vue?vue&type=style&index=0&id=343bc3ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343bc3ca",
  null
  
)

export default component.exports